import React from "react";

function article_1() {
	return {
		date: "April 2024",
		title: "Recipe Management System",
		description:
			"A web app built using Django that allows users to manage recipes with a user-friendly interface, data visualization, and user authentication.",
		keywords: [
			"Recipe Management System",
			"Sardar Sain",
			"Sardar Sain Projects",
			"Django Web App",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid green;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						This project involved building a dynamic recipe management system
						using Django, with features like user authentication, data
						visualization using Chart.js, and a responsive design with
						HTML, CSS, and Bootstrap.
					</div>
					<img
						src="https://picsum.photos/200/300"
						alt="Recipe Management"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "March 2024",
		title: "Car Rental Platform",
		description:
			"A secure platform for car rentals, featuring user sign-up, browsing, and bookings. Built with React, Node.js, and MongoDB for a seamless user experience.",
		keywords: [
			"Car Rental Platform",
			"Sardar Sain",
			"ReactJS",
			"Node.js",
			"MongoDB",
		],
		style: ``,
		body: (
			<React.Fragment>
				<div className="article-content">
					<p>
						This project focused on developing a car rental platform with
						admin-approved car listings, secure payment gateways, and a
						user-friendly interface for browsing and booking cars.
					</p>
					<img
						src="https://picsum.photos/200/300"
						alt="Car Rental"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_3() {
	return {
		date: "January 2024",
		title: "Handmade Selling Website",
		description:
			"A marketplace where users can explore and purchase handmade products. Allows users to enroll as sellers, enabling them to list their products upon admin approval.",
		keywords: [
			"Handmade Selling Website",
			"E-commerce",
			"Sardar Sain",
			"Marketplace",
		],
		style: ``,
		body: (
			<React.Fragment>
				<div className="article-content">
					<p>
						This project was designed to create a user-friendly marketplace for handmade products. Users can browse products, make purchases, and sellers can list their items upon admin approval.
					</p>
					<img
						src="https://picsum.photos/200/300"
						alt="Handmade Selling"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_4() {
	return {
		date: "December 2023",
		title: "iNotebook: Note-taking App",
		description:
			"A React and Node.js based application that allows users to create daily notes and set reminders for their tasks.",
		keywords: [
			"iNotebook",
			"Note-taking App",
			"ReactJS",
			"Node.js",
		],
		style: ``,
		body: (
			<React.Fragment>
				<div className="article-content">
					<p>
						iNotebook is a simple yet effective application for managing daily notes. Users can easily create, edit, and delete notes while setting reminders for important tasks.
					</p>
					<img
						src="https://picsum.photos/200/300"
						alt="iNotebook"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_5() {
	return {
		date: "September 2022",
		title: "Assignment Help Website",
		description:
			"A platform that assists students in getting help with their assignments. Users can submit their assignments, and tutors can offer assistance.",
		keywords: [
			"Assignment Help",
			"Sardar Sain",
			"Student Assistance",
			"E-learning",
		],
		style: ``,
		body: (
			<React.Fragment>
				<div className="article-content">
					<p>
						This project aimed at creating a user-friendly platform where students can submit assignments and receive help from tutors. The website supports a variety of subjects and offers a seamless user experience.
					</p>
					<img
						src="https://picsum.photos/200/300"
						alt="Assignment Help"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_2, article_3, article_4, article_5];

export default myArticles;
